/* eslint-disable no-async-promise-executor */
import { canvasRequest } from '$/api/canvasRquest';
import APP from '$/api/api';
import {
  CommunityCardItem, CommunityCategoryItem, CommunityInfoResponse, CommunitySubmitParams,
} from './type';
/**
 * 社区提交
 *
 * @export
 * @param {CommunitySubmitParams} data
 * @return {*}
 */
export async function communitySubmit(data: CommunitySubmitParams) {
  return new Promise<{ room_id: string; }>(async (resolve, reject) => {
    const response = await canvasRequest.request(
      {
        method: 'POST',
        url: APP.roboneo.api.communitySubmit,
        data,
      },
    );
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

// 社区分类
export async function getCommunityCategory() {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<{ list: CommunityCategoryItem[]; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.communityCategory,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

// 社区列表
export async function getCommunityList(params: {
  category_id?: number;
  // 游标
  page?: number;
  // 每页条数
  count?: number;
}) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<{ list: CommunityCardItem[]; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        ...params,
      },
      method: 'GET',
      url: APP.roboneo.api.communityList,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

// 我用过的列表
export async function getCommunityUsedList(params: {
  // 游标
  page?: number;
  // 每页条数
  count?: number;
}) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<{ list: CommunityCardItem[]; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        ...params,
      },
      method: 'GET',
      url: APP.roboneo.api.communityUsedList,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

// 发布列表
export async function getCommunityPublishedList(params: {
  // 游标
  page?: number;
  // 每页条数
  count?: number;
}) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<{ list: CommunityCardItem[]; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        ...params,
      },
      method: 'GET',
      url: APP.roboneo.api.communityPublishedList,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}
// 案例/工作流/作品-详情
export async function getCommunityInfo(params: {
  // 房间ID
  room_id?: string;
}): Promise<CommunityInfoResponse> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const response = await canvasRequest.request({
        params: {
          ...params,
        },
        method: 'GET',
        url: APP.roboneo.api.communityInfo,
      });
      if (response.status === 200 && response.data.code === 0) {
        resolve(response.data.data);
        return;
      }
      reject(response);
    } catch (error) {
      reject(error);
    }
  });
}
// 执行后的保存--记录关系
export async function communitySave(data: {
  room_id: string;
  from_room_id: string;
}) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request(
      {
        method: 'POST',
        url: APP.roboneo.api.communitySave,
        data,
      },
    );
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}
export async function communityConfig(): Promise<{
  mcp_list: Array<{
    api_name: string;
    token: number;
  }>;
}> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.communityConfig,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

export async function communityShare(data: {
  room_id: string;
}) {
  // eslint-disable-next-line no-async-promise-executor
  return canvasRequest.request({
    method: 'POST',
    url: APP.roboneo.api.communityShare,
    data,
  });
}
